import { useMemo } from "react";

import { API_URLS } from "shared/constants";
import useHttpActions from "shared/services/api/core/useHttpActions";
import type { BackendEntityType, EntityRoles, PaginationParamsModel, PaginationTokenType } from "shared/types";
import { paginationTokenResolver } from "shared/types";

import BaseConverter from "./converters/baseConverter";

import { dataExportResolver } from "../types/DataExports";

const useExportsApiService = () => {
	const actions = useHttpActions();

	return useMemo(
		() => ({
			listExportedData: async (params: PaginationParamsModel) => {
				return BaseConverter.convert<{ dataExports: any[]; nextToken: PaginationTokenType }>(
					await actions.get(API_URLS.USER.LIST_MY_DATA_EXPORTS, params, {
						resolvers: [
							{
								fields: ["dataExports"],
								resolver: dataExportResolver
							},
							{
								fields: ["nextToken"],
								resolver: paginationTokenResolver
							}
						]
					})
				);
			},
			exportData: async (params: {
				entityId: string;
				entityType: BackendEntityType;
				dataType: BackendEntityType | EntityRoles;
				exportFormat?: "csv" | "pdf" | "xlsx";
			}) => {
				return BaseConverter.convert<{ success: boolean }>(await actions.post(API_URLS.SOCCER.EXPORT_DATA, params));
			}
		}),
		[actions]
	);
};

export default useExportsApiService;
